<template>
    <div class="pdf-viewer">
        <mc-loading
            :loading="loading"
            message="PDF加载中..."
        >
            <div
                v-if="error"
                class="pdf-viewer__error"
            >
                <p>{{ error }}</p>
                <el-button
                    size="small"
                    type="primary"
                    @click="loadPdf"
                >
                    重新加载
                </el-button>
            </div>
            <div
                v-else
                ref="pdfContainer"
                class="pdf-viewer__container"
            >
                <canvas
                    v-for="page in totalPages"
                    :key="page"
                    :ref="`canvas-${page}`"
                    class="pdf-viewer__page"
                ></canvas>
            </div>
        </mc-loading>
    </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

export default {
    name: 'PdfViewer',
    props: {
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            error: '',
            totalPages: 0,
            pdfDoc: null,
        };
    },
    watch: {
        url: {
            handler(val) {
                if (val) {
                    this.loadPdf();
                }
            },
            immediate: true,
        },
    },
    beforeDestroy() {
        if (this.pdfDoc) {
            this.pdfDoc.destroy();
            this.pdfDoc = null;
        }
    },
    methods: {
        async loadPdf() {
            if (!this.url) {
                return;
            }

            this.loading = true;
            this.error = '';
            this.totalPages = 0;

            // 设置 worker
            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

            try {
                const pdf = await pdfjsLib.getDocument(this.url).promise;
                this.pdfDoc = pdf;
                this.totalPages = pdf.numPages;

                // 等待 DOM 更新后渲染各页
                this.$nextTick(() => {
                    this.renderAllPages();
                });
            } catch (err) {
                this.error = `PDF加载失败: ${err.message || '未知错误'}`;
            } finally {
                this.loading = false;
            }
        },

        async renderAllPages() {
            for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
                await this.renderPage(pageNum);
            }
        },

        async renderPage(pageNum) {
            try {
                const page = await this.pdfDoc.getPage(pageNum);
                const scale = 1.5;
                const viewport = page.getViewport({ scale });

                const canvasRef = this.$refs[`canvas-${pageNum}`];
                const canvas = Array.isArray(canvasRef) ? canvasRef[0] : canvasRef;
                if (!canvas) {
                    return;
                }

                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({
                    canvasContext: context,
                    viewport,
                }).promise;
            } catch (err) {
                console.error(`PDF第${pageNum}页渲染失败:`, err);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.pdf-viewer {
    width: 100%;
    height: 100%;

    &__container {
        width: 100%;
        overflow-y: auto;
        text-align: center;
        background-color: #f5f5f5;
    }

    &__page {
        display: block;
        margin: 0 auto 10px;
        max-width: 100%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &__error {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 200px;
        color: #999;

        p {
            margin-bottom: 12px;
        }
    }
}
</style>
